/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseCodeInterpreterCallCodeDoneEvent = {
  type: "response.code_interpreter_call_code.done";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  code: string;
};

/** @internal */
export const ResponseCodeInterpreterCallCodeDoneEvent$inboundSchema: z.ZodType<
  ResponseCodeInterpreterCallCodeDoneEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.code_interpreter_call_code.done"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  code: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseCodeInterpreterCallCodeDoneEvent$Outbound = {
  type: "response.code_interpreter_call_code.done";
  sequence_number: number;
  item_id: string;
  output_index: number;
  code: string;
};

/** @internal */
export const ResponseCodeInterpreterCallCodeDoneEvent$outboundSchema: z.ZodType<
  ResponseCodeInterpreterCallCodeDoneEvent$Outbound,
  z.ZodTypeDef,
  ResponseCodeInterpreterCallCodeDoneEvent
> = z.object({
  type: z.literal("response.code_interpreter_call_code.done"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  code: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseCodeInterpreterCallCodeDoneEventToJSON(
  responseCodeInterpreterCallCodeDoneEvent:
    ResponseCodeInterpreterCallCodeDoneEvent,
): string {
  return JSON.stringify(
    ResponseCodeInterpreterCallCodeDoneEvent$outboundSchema.parse(
      responseCodeInterpreterCallCodeDoneEvent,
    ),
  );
}
export function responseCodeInterpreterCallCodeDoneEventFromJSON(
  jsonString: string,
): SafeParseResult<
  ResponseCodeInterpreterCallCodeDoneEvent,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseCodeInterpreterCallCodeDoneEvent$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ResponseCodeInterpreterCallCodeDoneEvent' from JSON`,
  );
}
